export const locale = {
  lang: 'it',
  data: {
    SHORTCUT: {
      ADD: {
        NEW_INVOICE: 'Fattura',
        NEW_CLIENT: 'Cliente',
        NEW_COMPANY: 'Azienda',
        MASSIVE_COMPANY_IMPORT: 'Import massivo aziende',
      },
      EXPORT: {
        AUCTION_FUTURE: 'Esporta aste future',
        AUCTION_PROGRESS: 'Esporta aste in corso',
        AUCTION_AWARDED: 'Esporta aste aggiudicate',
      },
      SNACKBAR: {
        CLIENT_ADDED: 'Cliente aggiunto con successo!',
        INVOICE_ADDED: 'Fattura aggiunta con successo!',
        COMPANY_ADDED: 'Azienda salvata con successo!',
        MASSIVE_COMPANY_ADDED: 'Importazione aziende avvenuto con successo: a breve saranno disponibili sul portale.',
      },
      WALLET_BALANCE: 'Saldo Wallet',
      EXPORT_CSV: 'Esporta come CSV',
      EXPORT_XLS: 'Esporta come XLS',
    },
  },
};
